import { useLocation } from "react-router-dom";

export const useIsOMS = () => {
  const location = useLocation();

  return location.pathname.includes("/oms");
};
